var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarMenuBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84277 5.12048C10.1137 5.40161 10.4448 5.63253 10.816 5.78313C10.4448 5.63253 10.1237 5.40161 9.84277 5.12048Z",
    fill: "#F22012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 5.78313C13.7059 5.55221 14.1674 5.17068 14.4885 4.68876C14.1674 5.17068 13.7059 5.55221 13.1641 5.78313Z",
    fill: "#F22012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4917 4.6988C9.59203 4.8494 9.71244 5 9.84287 5.13052C9.71244 5 9.59203 4.85944 9.4917 4.6988Z",
    fill: "#F22012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07358 2.95181H1.08361C0.481605 2.95181 0 3.43373 0 4.03614C0 4.63855 0.491639 5.12048 1.08361 5.12048H7.56522C7.25418 4.47791 7.07358 3.76506 7.07358 3.01205C7.07358 2.99197 7.07358 2.97189 7.07358 2.95181Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 7.89157H1.08361C0.481605 7.89157 0 8.37349 0 8.9759C0 9.57831 0.491639 10.0602 1.08361 10.0602H10.9565C11.5585 10.0602 12.0401 9.57831 12.0401 8.9759C12.0401 8.37349 11.5485 7.89157 10.9565 7.89157Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 12.8313H1.08361C0.481605 12.8313 0 13.3133 0 13.9157C0 14.5181 0.491639 15 1.08361 15H10.9565C11.5585 15 12.0401 14.5181 12.0401 13.9157C12.0401 13.3133 11.5485 12.8313 10.9565 12.8313Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.99 0C10.3245 0 8.97998 1.34538 8.97998 3.01205C8.97998 3.63454 9.17062 4.21687 9.49169 4.69879C9.59202 4.8494 9.71242 5 9.84286 5.13052C10.1138 5.41165 10.4449 5.64257 10.8161 5.79317C11.1773 5.94378 11.5686 6.03414 11.99 6.03414C12.4114 6.03414 12.8027 5.95381 13.1639 5.79317C13.7057 5.56225 14.1673 5.18072 14.4883 4.69879C14.8094 4.21687 15 3.63454 15 3.01205C15 1.34538 13.6556 0 11.99 0Z",
    fill: "#F22012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarMenuBadge);
export default __webpack_public_path__ + "static/media/BarMenuBadge.525c6ff341ad8cae777ed9bac835b86e.svg";
export { ForwardRef as ReactComponent };